import { useCallback, useState } from 'react';

import { Copy } from 'lucide-react';
import { FormGroup, DefaultTooltip, Button, Select, Separator, Col, Row, Label } from 'twyne-new.ui';

import ConfirmationPopover from '@/components/ConfirmationPopover';
import { useAppAlert } from '@Components/AppAlert';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';

export default function DuplicateEntity({ info, sites }) {
  const { definitions: { entityName }, events: { handleDuplicateEntry }, store: { siteSelected } } = useGrid()
  const { handleSuccess } = useAppAlert()

  const [siteId, setSiteId] = useState(null)

  const { row } = getInfo(info)

  const handleSubmit = useCallback(async siteId => {
    await handleDuplicateEntry(row, siteId)
    handleSuccess(`${entityName} duplicated!`)
  }, [row, handleDuplicateEntry, handleSuccess, entityName])

  const handleSelect = useCallback(async option => {
    const { value } = option || {}
    setSiteId(value)
  }, [])

  return <>
    <ConfirmationPopover
      target={<DefaultTooltip content='Duplicate' side='left'><Copy size={16} /></DefaultTooltip>}
      title={<span>Duplicate {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.description}`}</i></span>}
    >
      <Row>
        <Col>
          <FormGroup>
            <Label className='font-bold'>Where do you want to duplicate this entry?</Label>
            <Button color='success' className='w-full flex justify-center' onClick={() => handleSubmit(siteSelected.id)}>
              To this site
            </Button>
          </FormGroup>
        </Col>
        <Col>
          <Separator />
        </Col>
        <Col>
          <FormGroup>
            <Label className='font-bold'>Another site</Label>
            <Select value={siteId} options={sites} onChange={handleSelect} placeholder='Select the site' />
          </FormGroup>
        </Col>
        <Col>
          <Button disabled={!siteId} color={!siteId ? 'neutral' : 'success'} className='w-full flex justify-center' onClick={() => handleSubmit(siteId)}>
            To another site
          </Button>
        </Col>
      </Row>
    </ConfirmationPopover>
  </>
}
